// Pure tier math shared by the Bundle Builder panel (and grid badges if needed).
// Tiers come from the section's <script data-bb-tier-config> JSON — DISPLAY config.
// Truth for actual money is always /cart.js allocations (see panel drift guard).
(function () {
  'use strict';

  function parse(el) {
    if (!el) return [];
    try {
      var tiers = (JSON.parse(el.textContent).tiers || []).filter(function (t) {
        return isFinite(t.minQty) && t.minQty >= 1 && isFinite(t.pct) && t.pct > 0 && t.pct <= 100;
      });
      return tiers.sort(function (a, b) { return a.minQty - b.minQty; });
    } catch (e) {
      console.warn('[bundle-builder] bad tier config', e);
      return [];
    }
  }

  // Highest tier unlocked at quantity n (tiers sorted asc), or null.
  function active(tiers, n) {
    var hit = null;
    for (var i = 0; i < tiers.length; i++) {
      if (n >= tiers[i].minQty) hit = tiers[i];
    }
    return hit;
  }

  // Next tier above quantity n, or null when maxed out.
  function next(tiers, n) {
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].minQty > n) return tiers[i];
    }
    return null;
  }

  // Preview math from VARIANT-level prices before real /cart.js allocations exist.
  // lines = [{priceCents, qty}] -> {subtotalCents, pct, discountedCents}
  function simulate(tiers, lines) {
    var n = 0;
    var subtotal = 0;
    lines.forEach(function (l) {
      n += l.qty;
      subtotal += l.priceCents * l.qty;
    });
    var tier = active(tiers, n);
    var pct = tier ? tier.pct : 0;
    return {
      n: n,
      subtotalCents: subtotal,
      pct: pct,
      discountedCents: Math.round(subtotal * (100 - pct) / 100),
    };
  }

  // Kaching (cart drawer app) monkey-patches window.fetch: it auto-opens its
  // drawer on /cart/add.js and rewraps cart responses — which pops the drawer
  // mid-step-flow and intermittently corrupts the response body (step-2 add
  // error). A hidden about:blank iframe supplies a pristine same-origin fetch
  // that no app has patched. Cookies still flow (same origin).
  var cleanWin = null;
  function cleanFetch(path, opts) {
    try {
      if (!cleanWin || !cleanWin.fetch) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        f.src = 'about:blank';
        document.documentElement.appendChild(f);
        cleanWin = f.contentWindow;
      }
      return cleanWin.fetch(location.origin + path, opts);
    } catch (e) {
      return window.fetch(path, opts); // patched fetch still beats no fetch
    }
  }

  // Serialized cart requests: the store's Cloudflare throttles BURSTS of cart
  // calls (3 quick adds -> challenge HTML instead of JSON). All cart traffic
  // goes through one queue with >=900ms spacing and auto-retry w/ backoff.
  // Rejects with {unavailable:true, json} on a REAL 422 (sold out) — retrying
  // those is pointless. CF challenges (403/HTML) never reach Shopify, so
  // retrying them cannot double-add.
  var queue = Promise.resolve();
  var lastAt = 0;

  function attempt(path, opts, triesLeft) {
    return cleanFetch(path, opts).then(function (r) {
      // Shopify cart endpoints answer with content-type text/javascript (JSON
      // body regardless) — only text/html means a bot-check interstitial.
      var ct = r.headers.get('content-type') || '';
      var isJson = ct.indexOf('json') >= 0 || ct.indexOf('javascript') >= 0;
      if (r.ok && isJson) return r.json();
      if (r.status === 422 && isJson) {
        return r.json().then(function (j) { throw { unavailable: true, json: j }; });
      }
      throw { retryable: true, status: r.status };
    }).catch(function (e) {
      if (e && e.unavailable) throw e;
      if (triesLeft > 0) {
        return new Promise(function (res) { setTimeout(res, 1600); })
          .then(function () { return attempt(path, opts, triesLeft - 1); });
      }
      throw e;
    });
  }

  function cartRequest(path, opts, tries) {
    var run = queue.catch(function () {}).then(function () {
      var wait = Math.max(0, 900 - (Date.now() - lastAt));
      return new Promise(function (res) { setTimeout(res, wait); });
    }).then(function () {
      return attempt(path, opts, tries === undefined ? 2 : tries);
    }).then(
      function (v) { lastAt = Date.now(); return v; },
      function (e) { lastAt = Date.now(); throw e; }
    );
    queue = run;
    return run;
  }

  window.BBTiers = { parse: parse, active: active, next: next, simulate: simulate, cleanFetch: cleanFetch, cartRequest: cartRequest };
})();
